<template>
<div class="tecnomap-zone-container">
    <tecno-map
        ref="map"
        class="tecnomap-drawer"
        :options="finalOptions"
        @ready="mapReady"
        @destroy="ready = false"
        :loading="!ready"
        >
    </tecno-map>
</div>
</template>
<style lang="scss">
.tecnomap-zone-container .tecnomap-drawer .mapboxgl-map {
    width: 100%;
    height: 80vh;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 0px 11px 0px rgb(0 0 0 / 16%);
}
</style>
<script>
import TecnoMap from './Map'

export default {
    props: {
        config_map: {
            type: Object,
            required: true,
        },
        
        options: {
            type: Object,
            default: function() {
                return {
                    minZoom: 8,
                    maxZoom: 14,
                    currentZoom: 8,
                    style: '/core/v1/' + this.$root.country_full_name + '/style.json',

                    mapCenter: {
                        locate: false
                    },

                    features: {
                        uriCoords: false,
                        scrollZoom: false,
                        dragRotate: false,
                        touchZoomRotate: false,
                        interactive: true
                    },

                    modules: {
                        navigationControl: {
                            uiPosition: 'top-right',
                            zoom: true
                        },

                        drawer: {
                            maxRadiusKm: 2,
                            modes: [],
                            maxPolygons: 10,
                            clusterRadius: 35,
                            insideColor: this.config_map.inside_color,
                            outsideColor: this.config_map.outside_color,
                            fillColor: '#158140',
                            textColor: '#fff',
                            labelColor: '#fff',
                            labelColorDisabled: '#000',
                            fillOpacity: this.config_map.fill_opacity,
                            listen: true
                        },
                    }
                }
            }
        },

        districts: {
            type: Array|Object,
            required: true
        },

        selected_districts: {
            type: Array,
            required: true
        },

        selected_quarters: {
            type: Array,
            required: true
        },

        center: {
            type: Object,
            required: false
        },

        city: {
            type: Object,
            required: true,
        },

        contract: {
            type: String,
            required: true,
        },

        sector: {
            type: String,
            required: true,
        },

        section: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            cancelToken: null,
            ready: false,
            popup: null,
            userLocationAllowed: false,

            init: {
                layerHighlight: false,
            },
            zoomExceeded: {
                zoomIn: false,
                zoomOut: false
            }
        }
    },

    computed: {
        lang() {
            return this.$root.lang.tecnomap
        },

        finalOptions() {
            return {
                ...this.options,
                ...this.overrideOptions
            }
        }
    },

    watch: {
        districts(newValue, oldValue) {
            console.log('districts', oldValue, newValue)

            if(newValue != undefined && newValue != null)
            {
                if(typeof(newValue) == Array)
                    newValue = newValue.map(a => a.district_id)
                else
                    newValue = Object.keys(newValue)

                if(typeof(oldValue) == Array)
                    oldValue = oldValue.map(a => a.district_id)
                else
                    oldValue = Object.keys(oldValue)

                if (oldValue.length !== newValue.length)
                {
                    if(newValue.length > 0)
                        this.loadPolygons()
                    else
                        this.clearPolygons()
                }
            }
        },

        selected_districts(newValue, oldValue) {
            console.log('selected_districts', oldValue, newValue)
            this.$emit('update-districts', newValue)
        },

        selected_quarters(newValue, oldValue) {
            if(!_.isEqual(oldValue, newValue))
            {
                console.log('selected_quarters', newValue, oldValue)
                this.updatedDistricts()
            }
        }
    },

    methods: {
        registerListeners()
        {
            window.addEventListener('tecnomap.click.feature', this.toggleDistrict);
            window.addEventListener('tecnomap.drawer.loaded', this.enableLayers);
            window.addEventListener('tecnomap.navigationControl.geolocate.start', this.startGeolocating);
            window.addEventListener('tecnomap.navigationControl.geolocate.end', this.endGeolocating);
            window.addEventListener('tecnomap.navigationControl.geolocate.error', this.endGeolocating);
            window.addEventListener('tecnomap.navigationControl.geolocate.success', this.endGeolocating);
            window.addEventListener('tecnomap.navigationControl.zoom.exceeded', this.mapZoomExceeded);
            window.addEventListener('tecnomap.drawer.shapeUpdated', this.updatedDistricts);

        },

        unregisterListeners()
        {
            window.removeEventListener('tecnomap.drawer.loaded', this.enableLayers);
            window.removeEventListener('tecnomap.navigationControl.geolocate.start', this.startGeolocating);
            window.removeEventListener('tecnomap.navigationControl.geolocate.end', this.endGeolocating);
            window.removeEventListener('tecnomap.navigationControl.geolocate.error', this.endGeolocating);
            window.removeEventListener('tecnomap.navigationControl.geolocate.success', this.endGeolocating);
            window.removeEventListener('tecnomap.navigationControl.zoom.exceeded', this.mapZoomExceeded);
            window.removeEventListener('tecnomap.click.feature', this.toggleDistrict);
            window.removeEventListener('tecnomap.drawer.shapeUpdated', this.updatedDistricts);

        },

        updatedDistricts(event)
        {
            console.log('updatedDistricts', event)
            
            if(this.cancelToken != null)
                this.cancelToken.cancel();

            this.cancelToken = axios.CancelToken.source();

            axios.get('/api/estates/search-map-list', {
                cancelToken: this.cancelToken.token,
                params: {
                    aggregate_locations: true,
                    city: this.city.id,
                    contract: this.contract,
                    province: this.city.province_id,
                    sector: this.sector,
                    districts: this.selected_districts,
                    quarters: this.selected_quarters,
                    section: this.section
                }
            })
            .then((response) => {
                if(response != undefined)
                {
                    window.dispatchEvent(new CustomEvent('tecnomap.drawer.setMarkers', { detail: { 
                        id: this.$refs.map.id,
                        featureCollection: response.data.collection,
                        bounds: false
                    }}))
                }
            })
            .catch((error) => {
                console.log(error)
                window.dispatchEvent(new CustomEvent('tecnomap.drawer.setMarkers', { detail: { 
                    id: this.$refs.map.id,
                    featureCollection: {
                        type: "FeatureCollection",
                        features: []
                    }
                }}))
            })
        },

        toggleDistrict(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                let feature = event.detail.feature;
                if(this.selected_districts.includes(Number(feature.user_id)))
                {
                    // Da rimuovere
                    this.$emit('deselect', Number(feature.user_id));
                }
                else
                {
                    // Da aggiungere
                    this.$emit('select', Number(feature.user_id));
                }
            }
        },

        locate()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.navigationControl.geolocate', { detail: { id: this.$refs.map.id }}))
        },

        zoomIn()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.navigationControl.zoom.in', { detail: { id: this.$refs.map.id }}))
        },

        zoomOut()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.navigationControl.zoom.out', { detail: { id: this.$refs.map.id }}))
        },

        startGeolocating(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isGeolocating = true
            }
        },

        endGeolocating(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isGeolocating = false
            }
        },

        mapZoomExceeded(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.zoomExceeded = {
                    zoomIn: event.detail.zoomIn,
                    zoomOut: event.detail.zoomOut
                }
            }
        },

        mapReady(event)
        {
            this.ready = true
        },

        loadPolygons()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.drawer.reset', { detail: { id: this.$refs.map.id }}));
            axios.get('/api/estates/get-polygons', {
                params: {
                    districts: this.districts.map(a => a.district_id)
                }
            })
            .then((response) => {
                let systemFeatures = response.data;
                systemFeatures.features.forEach(feature => {
                    feature.properties.enabled = this.selected_districts.includes(Number(feature.properties.id));
                })

                window.dispatchEvent(new CustomEvent('tecnomap.drawer.setPolygons', { detail: { 
                    id: this.$refs.map.id, 
                    featureCollection: systemFeatures, 
                    editable: false,
                    bounds: true
                }}));
            })
            .catch((error) => {

            })
        },

        enableLayers(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                var map = event.detail.map;
                this.loadPolygons()

                map.on('sourcedata', (e) => {

                    if(e.sourceId == 'mapbox-gl-draw-cold' && this.init.layerHighlight == false)
                    {
                        console.log(e, this.init.layerHighlight)
                        this.init.layerHighlight = true
                        map.addLayer({
                            'id': 'gl-draw-polygon-highlighted',
                            'type': 'fill',
                            'source': 'mapbox-gl-draw-cold',
                            'paint': {
                                'fill-color': this.options.modules.drawer.insideColor,
                                'fill-outline-color': this.options.modules.drawer.outsideColor,
                                'fill-opacity':  this.options.modules.drawer.fillOpacity + 0.1,
                            },
                            'filter': ['==', 'user_id', '']
                        });

                        map.on('mousemove', 'gl-draw-polygon-fill-inactive.cold', (e) =>{
                            map.getCanvas().style.cursor = 'pointer';
                            var feature = e.features[0];
                            map.setFilter('gl-draw-polygon-highlighted', ['==', 'user_id', feature.properties.user_id]);
                            this.$emit('listHighlightOn', Number(feature.properties.user_id));
                        });

                        map.on('mouseleave', 'gl-draw-polygon-fill-inactive.cold', () => {
                            map.getCanvas().style.cursor = '';
                            map.setFilter('gl-draw-polygon-highlighted', ['==', 'user_id', '']);
                            this.$emit('listHighlightOff');
                        });
                    }
                });

                this.$on('update-districts', (event) => {
                    console.log('update-districts', event)
                    let systemFeatures = map.drawer.getAll();
                    systemFeatures.features.forEach(feature => {
                        if(event.length == 0)
                        {
                            feature.properties.enabled = true;
                        }
                        else
                        {
                            feature.properties.enabled = event.includes(Number(feature.properties.id));
                        }
                    })

                    console.log(systemFeatures)
                    // map.drawer.set(systemFeatures)

                    window.dispatchEvent(new CustomEvent('tecnomap.drawer.reset', { detail: { id: this.$refs.map.id}}))
                    window.dispatchEvent(new CustomEvent('tecnomap.drawer.setPolygons', { detail: { 
                        id: this.$refs.map.id, 
                        featureCollection: systemFeatures, 
                        editable: false,
                        bounds: (event.length == 0 && systemFeatures.features.length > 0)
                    }}));
                });

                this.$on('destroy', () => {
                    if (map.getLayer('gl-draw-polygon-highlighted')) 
                    {
                        map.removeLayer('gl-draw-polygon-highlighted');
                    }
                });

                this.$on('highlightOn', (id) => {
                    if (map.getLayer('gl-draw-polygon-highlighted')) 
                    {
                        map.setFilter('gl-draw-polygon-highlighted', ['==', 'user_id', String(id)]);
                    }
                });

                this.$on('highlightOff', (id) => {
                    if (map.getLayer('gl-draw-polygon-highlighted')) 
                    {
                        map.setFilter('gl-draw-polygon-highlighted', ['==', 'user_id', '']);
                    }
                });
            }
        },

        clearPolygons()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.drawer.reset', { detail: { id: this.$refs.map.id}}))
        },

        highlightOn(id)
        {
            this.$emit('highlightOn', id);
        },

        highlightOff(id)
        {
            this.$emit('highlightOff', id);
        },

    },

    created() {
        if(navigator && navigator.permissions){
            navigator.permissions.query({ name: 'geolocation' }).then((result) => {
                this.userLocationAllowed = (result.state == 'granted')
            })
        }

        if(this.$root.network == 'tecnorete')
        {
            this.options.modules.drawer = {
                ...this.options.modules.drawer,
                insideColor: '#003596',
                outsideColor: '#53BAFF',
                fillColor: '#003596',
                textColor: '#ffffff',
            }
        }

        if(this.center != undefined)
        {
            this.options.mapCenter.coords = [this.center['longitude'], this.center['latitude']];
        }
    },

    mounted() {
        this.registerListeners()
    },

    beforeDestroy() {
        console.log('Portale/Maps/Picker - beforeDestroy');
        this.$emit('destroy');
        this.unregisterListeners()
    },

    components: {
        'tecno-map': TecnoMap,
    }
}
</script>
